var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.061,
    height: 19.061,
    viewBox: "0 0 19.061 19.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_15_",
    "data-name": "calendar (15)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15639",
    "data-name": "Path 15639",
    d: "M16.6,1.489H14.892V.6A.6.6,0,1,0,13.7.6v.893H5.361V.6A.6.6,0,0,0,4.17.6v.893H2.457A2.46,2.46,0,0,0,0,3.946V16.6a2.46,2.46,0,0,0,2.457,2.457H16.6A2.46,2.46,0,0,0,19.061,16.6V3.946A2.46,2.46,0,0,0,16.6,1.489ZM17.87,16.6A1.266,1.266,0,0,1,16.6,17.87H2.457A1.266,1.266,0,0,1,1.191,16.6V6.738a.186.186,0,0,1,.186-.186H17.684a.186.186,0,0,1,.186.186Z",
    transform: "translate(0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6b27b733.svg";
export { ForwardRef as ReactComponent };